import type { LucideIcon } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';

interface FuturePlaceholderCardProps {
  title: string;
  emptyTitle: string;
  description: string;
  icon: LucideIcon;
}

/**
 * Reserved space on the profile for a module that has not shipped.
 *
 * Shows an honest empty state rather than invented history: a fabricated eye examination on a real
 * customer record is worse than a blank panel, because staff cannot tell it is fake.
 */
export function FuturePlaceholderCard({
  title,
  emptyTitle,
  description,
  icon,
}: FuturePlaceholderCardProps) {
  return (
    <Card>
      <CardHeader title={title} />
      <EmptyState icon={icon} title={emptyTitle} description={description} className="px-5 py-10" />
    </Card>
  );
}
